import qs from 'qs';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

function getParamsFromUrl(history) {
	return qs.parse(history.location.search, {
		ignoreQueryPrefix: true,
	});
}

export default function useQueryParams() {
	const history = useHistory();
	const location = useLocation();
	const urlParams = getParamsFromUrl(history);
	const [params, setParams] = useState(urlParams || {});

	useEffect(() => {
		const data = getParamsFromUrl(history);

		setParams(data);
	}, [location, history]);

	return { ...params, history, location };
}
